import { FC } from 'react';

interface FieldDisplayFullProps {
  fieldValue: string | null | undefined;
  className?: string;
  style?: React.CSSProperties;
}

const stripFieldFormat = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .trim()
    .replace(/^\[/, '')
    .replace(/\]$/, '')
    .replace(/^["']/, '')
    .replace(/["']$/, '')
    .trim();
};

export const FieldDisplayFull: FC<FieldDisplayFullProps> = ({ 
  fieldValue, 
  className = '',
  style = {},
}) => {
  if (!fieldValue) {
    return <span className={className} style={style}>?</span>;
  }

  const fullPath = stripFieldFormat(fieldValue);
  
  return (
    <span
      className={className}
      style={{
        cursor: 'default',
        ...style,
      }}
    >
      {fullPath}
    </span>
  );
};
